import { render, staticRenderFns } from "./datumManage.vue?vue&type=template&id=1d0bea98&scoped=true&"
import script from "./datumManage.vue?vue&type=script&lang=js&"
export * from "./datumManage.vue?vue&type=script&lang=js&"
import style0 from "./datumManage.vue?vue&type=style&index=0&id=1d0bea98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0bea98",
  null
  
)

export default component.exports